module.exports = __webpack_public_path__ + "img/shield_square.ab750370.svg";